import React from 'react'
import { mergeClassnames } from '@mote/helpers'
import { __DEV__ } from '@mote/helpers/constants'
import styled from '@xstyled/styled-components'
import { TableGenericContext } from './tableGeneric.context'

export const TableHead = React.forwardRef(
  ({ className, as = 'thead', ...props }, ref) => {
    return (
      <TableGenericContext.Provider value={{ variant: 'head' }}>
        <TableHeadRoot
          as={as}
          className={mergeClassnames('mote-table-head', className)}
          ref={ref}
          role={as === 'thead' ? null : 'rowgroup'}
          {...props}
        />
      </TableGenericContext.Provider>
    )
  }
)

if (__DEV__) {
  TableHead.displayName = 'TableHead'
}

const TableHeadRoot = styled.theadBox`
  display: table-header-group;
`
